const INDEX_ITEMS = [
  { title: '高口碑华语佳作', count: '128部', icon: 'ri-medal-line', desc: '豆瓣8.0以上华语电影精选合集' },
  { title: '近期热播剧集', count: '每日更新', icon: 'ri-fire-line', desc: '当下最火电视剧追更日历' },
  { title: '韩剧精选专区', count: '356部', icon: 'ri-heart-line', desc: '高分韩剧一口气刷完' },
  { title: '好莱坞大片', count: '892部', icon: 'ri-film-line', desc: '好莱坞经典与最新巨制' },
  { title: '动漫番剧库', count: '1200+部', icon: 'ri-ghost-line', desc: '日漫国漫全收录' },
  { title: '综艺欢乐汇', count: '468档', icon: 'ri-emotion-laugh-line', desc: '热门综艺全季收录' },
  { title: '纪录片天地', count: '320部', icon: 'ri-earth-line', desc: 'BBC、Discovery等精品纪录片' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">专题合集</h2>
          <p className="text-sm text-foreground-500 mt-2">按类型分类浏览，快速找到想看的影视内容</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {INDEX_ITEMS.slice(0, 7).map((item) => (
            <a
              key={item.title}
              href="#hero"
              className="bg-background-100 rounded-xl p-5 flex flex-col items-center text-center hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100/70 flex items-center justify-center mb-3 group-hover:bg-primary-200/70 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl`} />
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">{item.title}</h3>
              <span className="text-xs text-primary-500 font-medium mb-1">{item.count}</span>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}